"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsHyperlink = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplicationWorkflowThankYouBackButtons = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSL_1 = require("./ViewSL");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
Object.defineProperty(exports, "CommonControlsHyperlink", { enumerable: true, get: function () { return Hyperlink_1.Hyperlink; } });
var ApplicationWorkflowThankYouBackButtons = (function (_super) {
    __extends(ApplicationWorkflowThankYouBackButtons, _super);
    function ApplicationWorkflowThankYouBackButtons(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSL = ViewSL_1.viewSL.apply(_this);
        _this.viewSL.constructor && _this.viewSL.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowThankYouBackButtons.prototype.componentDidMount = function () {
        this.viewSL.mounted && this.viewSL.mounted.apply(this, arguments);
    };
    ApplicationWorkflowThankYouBackButtons.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSL.shouldUpdate)
            return this.viewSL.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    ApplicationWorkflowThankYouBackButtons.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSL.didUpdate && this.viewSL.didUpdate.apply(this, arguments);
    };
    ApplicationWorkflowThankYouBackButtons.prototype.componentWillUnmount = function () {
        this.viewSL.unmount && this.viewSL.unmount.apply(this, arguments);
    };
    ApplicationWorkflowThankYouBackButtons.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowThankYouBackButtons.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowThankYouBackButtons.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSL.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSL.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowThankYouBackButtons.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", gutterVertical: "Small", colsWidth: "12", colsWidthForSm: "Auto", colMainAxisAlignment: "Center", children: [
                        React.createElement(GridCol_1.GridCol, { key: 0, isVisible: _this.props.isCreateProfileVisible, children: [
                                React.createElement(Hyperlink_1.Hyperlink, { key: 0, buttonType: "Grey", displayType: "Block", hasLinkStyle: false, hasTextShadow: false, isEnabled: _this.props.areButtonsEnabled, text: _this.props.createProfileText, type: "Url", url: _this.props.createProfileUrl })
                            ] }),
                        React.createElement(GridCol_1.GridCol, { key: 1, children: [
                                React.createElement(Hyperlink_1.Hyperlink, { key: 0, buttonType: "Grey", displayType: "Block", hasLinkStyle: false, hasTextShadow: false, isEnabled: _this.props.areButtonsEnabled, text: _this.props.backToSearchText, type: "Url", url: _this.props.backToSearchUrl })
                            ] })
                    ] })
            ];
        };
        return root_handler();
    };
    ApplicationWorkflowThankYouBackButtons.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSL-applicationworkflowthankyoubackbuttons" }, this._renderView()));
    };
    ApplicationWorkflowThankYouBackButtons.defaultProps = {
        areButtonsEnabled: true, backToSearchText: '', backToSearchUrl: '', createProfileText: '', createProfileUrl: '', isCreateProfileVisible: true
    };
    return ApplicationWorkflowThankYouBackButtons;
}(React.Component));
exports.ApplicationWorkflowThankYouBackButtons = ApplicationWorkflowThankYouBackButtons;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowThankYouBackButtons"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowThankYouBackButtons/ApplicationWorkflowThankYouBackButtons.js
// module id = 371
// module chunks = 0 2